export default {
  avatar_url: "https://cdn.parcelpanel.com/front-end/common/imgs/post-layer-avatar-20220322.jpeg",
  nickname: "Jessie",
}
